import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Auth.css';

const LOGIN_REDIRECT_URL = 'https://web.quantumsync.tech/login';

const Login = () => {
  useEffect(() => {
    window.location.href = LOGIN_REDIRECT_URL;
  }, []);

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-box">
          <h1>Login</h1>
          <p className="auth-subtitle">Welcome back to QuantumSync</p>
          
          <form className="auth-form" onSubmit={(e) => e.preventDefault()}>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input 
                type="email" 
                id="email" 
                name="email" 
                placeholder="Enter your email"
                required
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input 
                type="password" 
                id="password" 
                name="password" 
                placeholder="Enter your password"
                required
              />
            </div>
            
            <div className="form-options">
              <label className="checkbox-label">
                <input type="checkbox" />
                <span>Remember me</span>
              </label>
              <a href="#forgot" className="forgot-link">Forgot password?</a>
            </div>
            
            <button type="submit" className="btn-auth-primary">Login</button>
          </form>
          
          <div className="auth-footer">
            <p>Don't have an account? <Link to="/signup">Sign up</Link></p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
